import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
export default {
  data() {
    return {
      rulesTrue: {
        //统一控件说明如下：
        // 名称设置：
        // 控件名称：单行文本框，限制为0-500个字符。
        // 默认情况下，将填入控件类型的名称。
        // 非必填。如果删除了控件名称，在控件位置上方会进行补位。如果控件名称过长，会根据页面宽度换行显示。
        controlName: [{
          required: false,
          message: this.$t('请输入') + this.$t('控件名称'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 500,
          message: '长度在 1 到 500 个字符之间',
          trigger: 'blur'
        }],
        // 提示文字：单行文本框，限制为0-100个字符。
        // 用于给控件提供提示信息。
        promptText: [{
          message: '长度最多为 100 个字符',
          trigger: 'blur'
        }],
        // 控件说明：单行文本框，限制为0-100个字符。
        // 如果填写了控件说明，控件名称后面会显示一个说明图标。鼠标悬停在图标上时，会显示说明内容。
        controlExplain: [{
          max: 100,
          message: '长度最多为 100 个字符',
          trigger: 'blur'
        }],
        // 其他：
        // 标识：单行文本框，必填，限制为1-50个字符。
        // 添加控件后会自动生成一个随机标识，但您也可以手动修改。如果输入框被清空并失去焦点后，将恢复为随机标识。
        mark: [{
          required: true,
          message: '请输入标识',
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: '长度在 1 到 50 个字符之间',
          trigger: 'blur'
        }],
        prefix: [{
          message: '请输入...',
          trigger: 'blur'
        }, {
          min: 1,
          max: 100,
          message: '长度在 1 到 50个字符',
          trigger: 'blur'
        }],
        suffix: [{
          message: '请输入....',
          trigger: 'blur'
        }, {
          min: 1,
          max: 100,
          message: '长度在 1 到 100个字符',
          trigger: 'blur'
        }],
        mark: [{
          required: true,
          message: '请输入....',
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: '长度在 1 到 100个字符',
          trigger: 'blur'
        }],
        phoneRules: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }, {
          pattern: /^1\d{10}$/,
          message: '手机号格式不正确',
          trigger: 'blur'
        }],
        idCardRules: [{
          required: true,
          message: '请输入身份证号'
        }, {
          pattern: /^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[0-9Xx]$/,
          message: '身份证号格式不正确'
        }],
        emailRules: [{
          required: false,
          message: '请输入邮箱',
          trigger: 'blur'
        }, {
          pattern: /^[a-zA-Z0-9_]{1,18}@[a-zA-Z0-9]+\.com$/,
          message: '邮箱格式不正确',
          trigger: 'blur'
        }]
      } //校验
      // isActive: -1, //选中的index
      // groupSelected: false,//控件组选中状态
    };
  },
  methods: {
    // 鼠标悬浮事件
    highlight(index) {
      this.item.isHighlighted = true;
    },
    // 鼠标移除的事件监听
    removeHighlight(index) {
      this.item.isHighlighted = false;
    },
    // 点击显示  下拉、上移、编辑按钮
    toggleSelection(index, item, type) {
      // this.isActive = index;
      this.SET_ACTIVE_IDX(index);
      item.isSelectedShow = true;
      // 显示 下拉、上移、编辑按钮
      item.isSelected = true;
      item.isCheck = true;

      //控件组判断
      if (item && item.controlType === 'controlGroup' && item.isCheck == true) {
        // this.groupSelected = true;
        this.SET_GROUP_SELECTED(true);
      } else {
        // this.groupSelected = false;
        this.SET_GROUP_SELECTED(false);
      }
      console.log(this.groupSelected, 'this.groupSelected------111111');
      this.changeFormDataArray(index, false);
    },
    // 修改数据的isCheck
    changeFormDataArray(idx) {
      console.log(idx, '----ddddd-----');
      this.formDataArray.forEach((item, index) => {
        if (idx === -1) {
          // 此时取消所有选中效果
          item.isCheck = false;
          console.log(this.groupSelected, '-----cancal----');
          if (item.control) {
            item.control.forEach(items => {
              items.isCheck = false;
            });
          }
        } else {
          if (this.groupSelected) {
            console.log('选中控件组le--------');
            //控件组
            if (item.control) {
              //已经插入数据
              item.control.forEach((items, idxs) => {
                if (idx === idxs) {
                  items.isCheck = true;
                } else {
                  items.isCheck = false;
                }
              });
              console.log(item.control, 'item.control------');
            } else {
              console.log('---------jjjj-------');
              item.isCheck = false;
            }
          } else {
            // 非控件组
            if (idx === index) {
              item.isCheck = true;
            } else {
              item.isCheck = false;
            }
            if (item.control) {
              item.control.forEach(items => {
                items.isCheck = false;
              });
            }
          }
        }
      });
      this.formDataArray = JSON.parse(JSON.stringify(this.formDataArray));
    },
    // 子组件更新formDataArray数据
    updateFormDataArray(index) {
      console.log(index, this.formDataArray[this.isActive].control, '--------');
      this.formDataArray[this.isActive].control.forEach((item, idx) => {
        if (index === idx) {
          item.isCheck = true;
        } else {
          item.isCheck = false;
        }
      });
      this.formDataArray = JSON.parse(JSON.stringify(this.formDataArray));
    },
    // 关联控件
    relationClick(index) {
      this.relationModelVisible = true;
      this.relationModelIndex = index;
      this.relationModelData = this.formDataArray;
      let relationArr = [];
      this.formDataArray.forEach((item, index1) => {
        console.log(item);
        console.log(item.partsType);
        if (['singleChoice', 'multipleChoice', 'dropDown'].indexOf(item.partsType) != -1 && index1 < index) {
          relationArr.push(item);
        }
      });
      this.relationData = relationArr;
    },
    // 编辑按钮--打开内容输入内容
    formeClick(index, type) {
      this.activeIndex = index;
      console.log('编辑按钮', this.activeIndex);
      // console.log('编辑点击事件', item, index);
      if (type === 'table') {
        //表格控件的编辑特殊处理
        this.tableId = this.item.containerTemplateId;
        if (this.tableId !== -1) {
          let obj = {
            type: 'table',
            tableType: 'increment',
            tableUsage: 'control',
            id: this.tableId,
            mark: this.item.mark
          };
          sessionStorage.setItem('tableInitInfo', JSON.stringify(obj));
          this.tableDesignModelVisible = true;
        } else {
          this.tableMark = this.item.mark;
          this.containerVisible = true;
        }
      } else {
        this.item.editing = !this.item.editing;
      }
    }
  }
};